module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Our news"},"fr":{"title":"Nos actualités"}}')
  delete Component.options._Ctor
}
